import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ToastContext } from '../../contexts/ToastContext';

const variantStyles = {
  success: {
    bg: 'var(--green-100)',
    border: 'var(--green-300)',
    color: 'var(--green-900)',
    icon: '✓',
  },
  error: {
    bg: 'var(--danger-100)',
    border: 'var(--danger-300)',
    color: 'var(--danger-900)',
    icon: '!',
  },
  info: {
    bg: 'var(--blue-100)',
    border: 'var(--blue-300)',
    color: 'var(--blue-900)',
    icon: 'i',
  },
  warning: {
    bg: 'var(--warning-100)',
    border: 'var(--warning-600)',
    color: 'var(--warning-900)',
    icon: '!',
  },
};

export const Toaster: React.FC = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) return null;

  return (
    <>
      <style>{`
        @keyframes toastSlideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
      <div
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          maxWidth: 400,
          pointerEvents: 'none',
        }}
      >
        {ctx.toasts.map((toast) => {
          const styles = variantStyles[toast.variant];
          return (
            <div
              key={toast.id}
              onClick={() => ctx.dismiss(toast.id)}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                padding: '12px 16px',
                background: styles.bg,
                color: styles.color,
                border: `1px solid ${styles.border}`,
                borderRadius: 'var(--radius-md)',
                boxShadow: 'var(--shadow-md)',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                pointerEvents: 'auto',
                animation: 'toastSlideIn 250ms cubic-bezier(0.4, 0, 0.2, 1)',
                minWidth: 280,
              }}
            >
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  background: styles.color,
                  color: styles.bg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 700,
                  flexShrink: 0,
                  marginTop: 1,
                }}
              >
                {styles.icon}
              </div>
              <span style={{ flex: 1, lineHeight: 1.4 }}>
                {toast.message}
                {toast.link ? (
                  <Link
                    to={toast.link.to}
                    onClick={() => ctx.dismiss(toast.id)}
                    style={{
                      display: 'block',
                      marginTop: 4,
                      color: 'inherit',
                      fontWeight: 700,
                      textDecoration: 'underline',
                    }}
                  >
                    {toast.link.label} →
                  </Link>
                ) : null}
              </span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  ctx.dismiss(toast.id);
                }}
                style={{
                  color: styles.color,
                  fontSize: 16,
                  opacity: 0.5,
                  background: 'transparent',
                  padding: 0,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};